<template>
    <div>
        <app-navbar v-if="renderNavbar" :active.sync="showJoinModal" />
        <slot></slot>
        <session-join-modal
            v-if="showJoinModal"
            @close="showJoinModal = false"
            @join="navigateToSession"
        />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar';
import SessionJoinModal from '@/components/SessionJoinModal';
export default {
    components: {
        AppNavbar,
        SessionJoinModal,
    },
    data() {
        return {
            showJoinModal: false,
        };
    },
    computed: {
        renderNavbar() {
            return this.$store.getters.renderNavbar
        }
    },
    methods: {
        navigateToSession({ code }) {
            this.$router.push({ name: 'play', query: { code } });
        },
    },
};
</script>

<style></style>
